import { formatData } from "./utils";

/*stock : {
    idProd:
    idLocation:
    quantity:
}*/

export function getInventory(inventory){
    console.log("FIRED ACTION GET INVENTORY", inventory)
    return {
        type: "GET_INVENTORY",
        payload: inventory
        
    }
}

export function fetchStocks(){
    return async function(dispatch){
        try{
            console.log("FETCH STOCKS START")
            const res = await fetch('/stocks/list',{
                method:'GET',
                headers: new Headers({ 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                }),
                credentials: 'same-origin',
            })
            let list = await res.json();
            console.log({list});
            
            if (list){
                list = formatData(list.reverse())
                dispatch(getInventory(list))
            }
        } catch(err) {
            console.log("[ERROR] refetch stocks ", err);
        }
    }
}